/* global sessionStorage */

export const getSessionStorageItem = name => sessionStorage.getItem(name)
export const setSessionStorageItem = (name, value) => sessionStorage.setItem(name, value)
export const removeSessionStorageItem = name => sessionStorage.removeItem(name)
